export default "__VITE_ASSET__CWiKQZZK__"